import "./styles.less";

import { Col, Row, Typography } from "antd";

export const FinancingInput = ({
	title,
	input,
	slider = null,
	bottom = null,
	centerBottom = null,
	fullWidth = false,
	isDisabledProperty = false,
}) => {
	return (
		<div className="financing-col">
			<Row className="inputs-col">
				<Col xs={24} md={fullWidth ? 24 : 12}>
					<Typography.Paragraph strong>{title}</Typography.Paragraph>
				</Col>
				<Col xs={24} md={fullWidth ? 24 : 12}>
					{input}
				</Col>
				{slider ? <Col xs={24}>{slider}</Col> : null}
				{bottom ? (
					<Col xs={24} style={centerBottom ? { textAlign: "center" } : null}>
						{bottom}
					</Col>
				) : null}
			</Row>
		</div>
	);
};
